import { ThemeTonalRange, ToastLevel, ToastType } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { Closeable, CloseEventListener } from '@philips-emr/tws-core/lib/component/types';

class ToastNotificationAPI extends ComponentAPI implements Closeable {

  /** @event */
  @AwesomeEvent
  onBeforeClose = new CloseEventListener();

  /** @event */
  @AwesomeEvent
  onClose = new CloseEventListener();

  close(): void {
    let close = true;

    const abort = (): void => { close = false; };
    this.onBeforeClose.fire({ abort });

    if (close) {
      this.onClose.fire();
    }
  }

  isDismissible(): boolean {
    return this.state.dismissible;
  }

  setDismissible(dismissible: boolean): void {
    this.setState({ dismissible });
  }

  getLevel(): ToastLevel | undefined {
    return this.state.level;
  }

  setLevel(level?: ToastLevel): void {
    this.setState({ level });
  }

  getMessage(): string {
    return this.state.message;
  }

  setMessage(message: string): void {
    this.setState({ message });
  }

  getTheme(): ThemeTonalRange | undefined {
    return this.state.theme;
  }

  setTheme(theme?: ThemeTonalRange): void {
    this.setState({ theme });
  }

  getTimeout(): number | undefined {
    return this.state.timeout;
  }

  setTimeout(timeout?: number): void {
    this.setState({ timeout });
  }

  getTitle(): string | undefined {
    return this.state.title;
  }

  setTitle(title?: string): void {
    this.setState({ title });
  }

  getType(): ToastType | undefined {
    return this.state.type;
  }

  setType(type?: ToastType): void {
    this.setState({ type });
  }

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ visible });
  }
}

export default ToastNotificationAPI;
